// extracted by mini-css-extract-plugin
export default {"wrapper":"intentions_wrapper__gu9jh","image":"intentions_image__fIg2H","inside":"intentions_inside__syx+f"};